// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  width: 100%;
  text-align: center;
  padding: 0 15px;
}
h2 ion-icon {
  color: #1e2023;
  margin-bottom: -3px;
}

.share-link-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 50px;
}
.share-link-content .label-copy-link {
  padding: 0 15px;
}
.share-link-content ion-button {
  width: 100%;
  margin: 0 40px;
}
.share-link-content .copied-link-btn {
  --background: var(--ion-color-light);
  --background-hover: var(--ion-color-light);
  --background-activated: var(--ion-color-light);
  --background-focused: var(--ion-color-light);
  color: var(--ion-color-secondary);
}

.close-button {
  font-size: 14px;
  position: fixed;
  bottom: 20px;
  left: 5px;
  color: var(--ion-color-danger);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
